// Hooks de dados das sugestões (fatia S3b).
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { ApplyRecommendationResponse, RecommendationsResponse } from '@impulso/shared/api/recommendations'
import { api } from '../../lib/api'

export type RecStatusFilter = 'open' | 'applied' | 'dismissed' | 'all'

export const recKeys = {
  list: (companyId: string, status: RecStatusFilter = 'open') => ['recommendations', companyId, status] as const,
  all: (companyId: string) => ['recommendations', companyId] as const,
}

export function useRecommendations(companyId: string, status: RecStatusFilter = 'open', opts: { refetchInterval?: number } = {}) {
  return useQuery({
    queryKey: recKeys.list(companyId, status),
    queryFn: () => api.get<RecommendationsResponse>(`/companies/${companyId}/recommendations?status=${status}`),
    enabled: !!companyId,
    refetchInterval: opts.refetchInterval,
  })
}

export function useApplyRecommendation(companyId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.post<ApplyRecommendationResponse>(`/companies/${companyId}/recommendations/${id}/apply`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: recKeys.all(companyId) })
      void qc.invalidateQueries({ queryKey: ['actions', companyId] })
    },
  })
}

export function useDismissRecommendation(companyId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (v: { id: string; reason?: string | null }) => api.post<{ ok: true }>(`/companies/${companyId}/recommendations/${v.id}/dismiss`, { reason: v.reason ?? null }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: recKeys.all(companyId) }),
  })
}
